module.exports = __webpack_public_path__ + "img/rain.e13be320.svg";